import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { LoaderModel } from './loader.model';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private queue = 0;

  private loaderObservable$: BehaviorSubject<LoaderModel> = new BehaviorSubject<LoaderModel>({show: false});

  spinner: Observable<LoaderModel> = this.loaderObservable$.asObservable();

  show(text?: string) {
    this.queue = this.queue + 1;
    this.loaderObservable$.next({show: true, text: text});
  }

  hide() {
    this.queue = this.queue <= 0 ? 0 : this.queue - 1;

    if (this.queue === 0) {
      this.loaderObservable$.next({show: false});
    }
  }
}
